/**
 * @typedef	{{disabled?: boolean; isGettingData?:boolean; onChange:(event: React.ChangeEvent<HTMLInputElement>)=>void; onSubmit: (event: React.ChangeEvent<HTMLInputElement>)=> Promise<void>}} Props
 */

import { translate } from '../../Internationalization';
import FieldRadioGroup from '../../../shared/Forms/Fields/FieldRadioGroup';
import Loading from '../../../shared/Loading';
import React from 'react';

const label = 'global.offers.vendor_exclusivity.radio_labels';
const title = translate(
	`settings.communications.campaign.market_activity.title`
);

/**
 * @param {Props} props
 * @returns {JSX.Element}
 */
function AgentCommunicationRadio(props) {
	if (props.isGettingData) {
		return (
			<div>
				<span className="input-label h-ms-2">{title}</span>
				<div className="w-fit -ml-5 -mt-2 mb-2 -scale-50 [&>div]:p-0">
					<Loading />
				</div>
			</div>
		);
	}

	return (
		<FieldRadioGroup
			className="communication-preference"
			disabled={props.disabled}
			id={'market_activity'}
			label={translate(
				`settings.communications.campaign.market_activity.title`
			)}
			labelClassName="h-ms-2"
			name={'marketActivity'}
			onChange={props.onChange}
			title={title}
			values={[true, false].map((value) => [
				`${value}`,
				translate(`${label}.${value ? 'yes' : 'no'}`),
			])}
		/>
	);
}

export default React.memo(AgentCommunicationRadio);
